import { injectTypes } from 'Api/Plugins/Orano';
import { DpCodePrestationType, DpCodePriority, DPPrestationTypes, DPPriorities, WRHeaderCreate } from 'Api/Plugins/Orano/Dtos';
import { IGmaoService } from 'Api/Plugins/Orano/Interfaces';
import { LocalizerService } from 'Api/Services';
import VoDatePicker from 'App/Areas/Shares/FormInputs/VoDatePicker.vue';
import { lazyInject } from 'App/Inversify.config';
import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { Component } from 'Framework/Components/UIElement';

@Component({
    name: 'OranoCreateDPDialog',
    components: {
        VoDatePicker
    }
})
export default class OranoCreateDPDialog extends BaseDialogBehavior<{ ecode: string, result: WRHeaderCreate }> {
    public async beforeOkAsync(): Promise<boolean> {
        try {
            const newDP = await this._ventixService.createDPAsync(
                this._dataContext.ecode,
                this.title,
                this.description,
                this.originator,
                this.type,
                this.priority,
                this.currentDate
            );

            if (newDP) {
                this.dataContext.result = newDP;

                return true;
            }

            return false;
        }
        catch (e) {
            console.log(e);

            return false;
        }
    }

    public formatTime(date: Date): string {
        return this._localizerService.localizeDate(date).format('LT');
    }

    public get minDate(): string {
        const oneDay = 24 * 60 * 60 * 1000;

        return this._localizerService.getISODate(new Date(Date.now() + oneDay));
    }

    public get date(): string {
        return this._localizerService.getISODate(this.currentDate);
    }

    public set date(value: string) {
        this.currentDate = new Date(`${value}T${this.time}:00.000${this.timeZone}`);
    }

    public get time(): string {
        return this._localizerService.getISOTime(this.currentDate);
    }

    public set time(value: string) {
        this.currentDate = new Date(`${this.date}T${value}:00.000${this.timeZone}`);
    }

    public get timeZone(): string {
        const offset = (this._localizerService.utcOffset / 60);
        const offsetString = offset.toString().padStart(2, '0');

        return offset >= 0
            ? `+${offsetString}:00`
            : `-${offsetString}:00`;
    }

    public title: string = '';
    public description: string = '';
    public type: DpCodePrestationType = 'C1';
    public priority: DpCodePriority = 'E1';
    public originator: string = '';
    public currentDate: Date = new Date(Date.now());

    public isFormTimeOpen: boolean = false;

    public priorities = DPPriorities;
    public prestationTypes = DPPrestationTypes;

    @lazyInject(LocalizerService)
    private readonly _localizerService: LocalizerService;

    @lazyInject(injectTypes.IGmaoService)
    private readonly _ventixService: IGmaoService;
}
